import { useEffect, useState, useCallback } from "react";
import { usersService } from "features/users/services/users-service";
import type { User } from "features/users/types";

const defaultUserValues: User = {
  id: null,
  email: "",
  name: "",
  role: 40,
  languages: [
    { id: "en", name: "" },
    { id: "ru", name: "" },
  ],
};

export const useUser = (id?: string, isCreate?: boolean): [User | undefined, boolean, () => void] => {
  const [user, setUser] = useState<User | undefined>(isCreate ? defaultUserValues : undefined);
  const [isFetching, setIsFetching] = useState(false);
  const [refetchIndex, setRefetchIndex] = useState(0);

  const refetch = useCallback(() => {
    setRefetchIndex(prevRefetchIndex => prevRefetchIndex + 1);
  }, []);

  useEffect(() => {
    const abortController = new AbortController();

    if (isCreate) {
      return () => {};
    }

    async function fetchData() {
      try {
        setIsFetching(true);
        const response: User = await usersService.getUser(id!, abortController);
        setUser(response);
      } catch (error) {
        console.error(error);
      } finally {
        setIsFetching(false);
      }
    }

    fetchData();

    return () => {
      abortController.abort();
    };
  }, [id, isCreate, refetchIndex]);

  return [user, isFetching, refetch];
};
